import React from 'react';
import '../resources-dialog.css';
import DatabaseTable from './DatabaseTable';
import {
	InfrastructureResourceType,
	IRelationalDatabaseInfrastructureResource,
} from '@elyx-code/definitions';
import { EditorService } from '../../../services/editor';
import { useParams } from 'react-router-dom';
import RelationalDatabaseSecrets from './RelationalDatabaseSecrets';
import { Logger } from '@elyx-code/common-ts-utils';

export interface IRelationalDatabaseProps {
	onClose: () => void;
	project: EditorService;
}

const RelationalDatabase: React.FC<IRelationalDatabaseProps> = ({
	onClose,
	project,
}) => {
	const { projectId, resourceId } = useParams<{
		projectId: string;
		resourceId: string;
	}>();

	const resource = project?.liveResources.find(
		(resource) =>
			resource.resourceType === InfrastructureResourceType.RelationalDatabase &&
			resource.resourceId === resourceId
	);

	if (!resource) {
		return null;
	}

	const secrets = resource.details;
	Logger.log('Databse secrets: ', secrets);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				marginBottom: '28px',
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '16px',
					marginLeft: '80px',
					marginTop: '28px',
					marginBottom: '4px',
				}}
			>
				<p
					style={{
						margin: '0px',
						color: 'rgba(0,0,0,0.7)',
						fontSize: '14px',
					}}
				>
					These resources are currently in use in your live project.
					<br />
					By making changes to them, you might disrupt your user's experience.
				</p>
			</div>

			{/* Secrets */}
			<RelationalDatabaseSecrets
				resource={resource as IRelationalDatabaseInfrastructureResource}
			/>

			<section style={{ marginTop: 6 }}>
				<DatabaseTable project={project} />
			</section>
		</div>
	);
};

export default RelationalDatabase;
